
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.057.958l-1.566 3.053a21.478 21.478 0 01-4.434 5.866l-.205.186c-1.167 1.08-1.833 2.56-1.852 4.11v.197c-.03 3.036 1.866 5.79 4.8 6.967l.297.12c1.925.78 4.098.78 6.023 0h.068c2.956-1.226 4.853-4.024 4.811-7.098V9.626c-.985 2.147-2.774 3.865-5.016 4.82h-.069c-.069 0-.869.316-1.211 0a.8.8 0 01-.069-1.09l.08-.055h.057c2.624-1.903 3.235-5.428 1.394-8.036C13.68 3.106 12.057.958 12.057.958z","fill":"#000"}})])
          )
        }
      }
    